import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  IconButton,
  Stepper,
  Step,
  StepLabel,
  Grid,
  Fade,
  Chip,
  Divider,
  useTheme,
  alpha,
  Menu,
  ListItemIcon,
  ListItemText
} from "@mui/material";
import {
  Add as AddIcon,
  Person as PersonIcon,
  Email as EmailIcon,
  Work as WorkIcon,
  ArrowBack as ArrowBackIcon,
  Save as SaveIcon,
  LocationOn as LocationIcon,
  ContactPage as ContactIcon,
  FileDownload as ExportIcon,
  Delete as DeleteIcon,
  MoreVert as MoreIcon
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import styled from 'styled-components';
import config from '../../../../../config/config.json';
import { apiCall } from '../../../../../services/ApiCall';

// Styled Components

const HeaderWrapper = styled(Box)`
  margin-bottom: 24px;
  padding: 0 16px; 

`;
const StyledContainer = styled(Box)`
 
  min-height: 100vh;
  padding: 24px;
`;

const HeaderCard = styled(Card)`
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(13, 110, 253, 0.12) !important;
  border: 1px solid rgba(13, 110, 253, 0.1);
  margin-bottom: 24px;
  position: relative;
  overflow: hidden;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%);
  }
`;

const ContactCard = styled(Card)`
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(13, 110, 253, 0.1) !important;
  border: 1px solid rgba(13, 110, 253, 0.08);
  margin-bottom: 20px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(13, 110, 253, 0.15) !important;
  }
`;

const StyledTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    border-radius: 12px !important;
    background: rgba(255, 255, 255, 0.9);
    transition: all 0.3s ease !important;
    
    &:hover {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 4px 12px rgba(13, 110, 253, 0.1);
    }
    
    &.Mui-focused {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.2);
    }
  }
  
  .MuiInputLabel-root {
    font-weight: 500;
    
    &.Mui-focused {
      color: #0d6efd;
    }
  }
`;

const StyledFormControl = styled(FormControl)`
  .MuiOutlinedInput-root {
    border-radius: 12px !important;
    background: rgba(255, 255, 255, 0.9);
    transition: all 0.3s ease !important;
    
    &:hover {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 4px 12px rgba(13, 110, 253, 0.1);
    }
    
    &.Mui-focused {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.2);
    }
  }
  
  .MuiInputLabel-root {
    font-weight: 500;
    
    &.Mui-focused {
      color: #0d6efd;
    }
  }
`;

const AddContactButton = styled(Button)`
  background: linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%) !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(13, 110, 253, 0.3) !important;
  }
`;

const ActionButton = styled(Button)`
  border-radius: 12px !important;
  padding: 12px 32px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const ExportButton = styled(Button)`
  background: linear-gradient(135deg, #4caf50 0%, #45a049 100%) !important;
  border-radius: 12px !important;
  padding: 10px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(76, 175, 80, 0.3) !important;
  }
`;

const StyledMenu = styled(Menu)`
  .MuiPaper-root {
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(20px);
    border-radius: 16px !important;
    border: 1px solid rgba(13, 110, 253, 0.1);
    box-shadow: 0 8px 32px rgba(13, 110, 253, 0.15) !important;
    min-width: 180px;
    margin-top: 8px;
  }
  
  .MuiMenuItem-root {
    border-radius: 8px !important;
    margin: 4px 8px !important;
    transition: all 0.2s ease !important;
    
    &:hover {
      background: rgba(13, 110, 253, 0.08) !important;
      transform: translateX(4px);
    }
  }
`;

function SiteContact({ answer, setAnswer, onSwitchToDetail }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const changeFname = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      userData: {
        ...prevAnswer.userData,
        fname: e.target.value,
      },
    }));
  };

  const changeLname = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      userData: {
        ...prevAnswer.userData,
        lname: e.target.value,
      },
    }));
  };

  const changeEmail = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      userData: {
        ...prevAnswer.userData,
        email: e.target.value,
      },
    }));
  };

  const changeDesignation = (e) => {
    setAnswer((prevAnswer) => ({
      ...prevAnswer,
      userData: {
        ...prevAnswer.userData,
        designation: e.target.value,
      },
    }));
  };

  const addNewSitesAndContact = async (e) => {
    e.preventDefault();
    setSaving(true);
    const { isSuccess, data } = await apiCall(
      `${config.POST_LOGIN_API_URL}addNewSitesAndContact`,
      {},
      { ...answer },
      "POST"
    );
    setSaving(false);
    if (isSuccess) {
      navigate("/site-list");
    }
  };

  const designationOptions = [
    "Site Admin",
    "Site Manager"
  ];

  return (
    <StyledContainer>
      {/* Header Section */}
     <HeaderWrapper>
           <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
             <IconButton 
               onClick={onSwitchToDetail}
               sx={{ mr: 1 }} 
             >
               <ArrowBackIcon />
             </IconButton>
             <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
               Add Site
             </Typography>
           </Box>
         
           <Box>
             <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
               <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'text.primary' }}>
                 Step 2 of 2
               </Typography>
               <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                 Contact Information
               </Typography>
             </Box>
             <Box sx={{ flexGrow: 1, height: '8px', background: alpha('#0d6efd', 0.2), borderRadius: '4px', overflow: 'hidden' }}>
               <Box sx={{ width: '100%', height: '100%', background: '#0d6efd', borderRadius: '4px' }} /> {/* 100% width for step 2 */}
             </Box>
           </Box>
         </HeaderWrapper>

      {/* Contact Form */}
      <form onSubmit={addNewSitesAndContact}>
        <Fade in timeout={500}>
          <ContactCard>
            <CardContent sx={{ p: 3 }}>
              {/* Contact Header */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <ContactIcon sx={{ color: '#0d6efd', mr: 2, fontSize: 28 }} />
                  <Typography variant="h6" sx={{ fontWeight: 600, color: '#1a202c' }}>
                    Site Contact Information
                  </Typography>
                  <Chip 
                    label="Primary"
                    size="small"
                    sx={{ 
                      ml: 2,
                      background: alpha('#4caf50', 0.1),
                      color: '#4caf50',
                      fontWeight: 600
                    }}
                  />
                </Box>
                
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <AddContactButton
                    variant="contained"
                    startIcon={<AddIcon />}
                  >
                    Add Contact
                  </AddContactButton>
                  
                  <IconButton
                    sx={{
                      color: '#f44336',
                      background: alpha('#f44336', 0.1),
                      '&:hover': {
                        background: alpha('#f44336', 0.2),
                        transform: 'scale(1.05)'
                      }
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              </Box>

              <Divider sx={{ mb: 3, borderColor: alpha('#0d6efd', 0.1) }} />

              {/* Form Fields */}
              <Grid container spacing={3}>
                {/* Name Fields */}
                <Grid item xs={12} md={6}>
                  <StyledTextField
                    fullWidth
                    label="First Name"
                    value={answer.userData?.fname || ''}
                    onChange={changeFname}
                    InputProps={{
                      startAdornment: (
                        <PersonIcon sx={{ color: '#64748b', mr: 1 }} />
                      ),
                    }}
                    required
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <StyledTextField
                    fullWidth
                    label="Last Name"
                    value={answer.userData?.lname || ''}
                    onChange={changeLname}
                    InputProps={{
                      startAdornment: (
                        <PersonIcon sx={{ color: '#64748b', mr: 1 }} />
                      ),
                    }}
                  />
                </Grid>

                {/* Email Field */}
                <Grid item xs={12} md={6}>
                  <StyledTextField
                    fullWidth
                    label="Email"
                    type="email"
                    value={answer.userData?.email || ''}
                    onChange={changeEmail}
                    InputProps={{
                      startAdornment: (
                        <EmailIcon sx={{ color: '#64748b', mr: 1 }} />
                      ),
                    }}
                    required
                  />
                </Grid>

                {/* Designation Field */}
                <Grid item xs={12} md={6}>
                  <StyledFormControl fullWidth required>
                    <InputLabel>Designation</InputLabel>
                    <Select
                      value={answer.userData?.designation || ''}
                      onChange={changeDesignation}
                      label="Designation"
                      startAdornment={
                        <WorkIcon sx={{ color: '#64748b', mr: 1 }} />
                      }
                    >
                      {designationOptions.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </StyledFormControl>
                </Grid>
              </Grid>
            </CardContent>
          </ContactCard>
        </Fade>

        {/* Action Buttons */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
          <ActionButton
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={onSwitchToDetail}
            disabled={saving}
            sx={{
              borderColor: '#64748b',
              color: '#64748b',
              '&:hover': {
                borderColor: '#0d6efd',
                color: '#0d6efd',
                background: alpha('#0d6efd', 0.05)
              }
            }}
          >
            Previous
          </ActionButton>

          <ActionButton
            type="submit"
            variant="contained"
            startIcon={<SaveIcon />}
            disabled={saving}
            sx={{
              background: 'linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)',
              '&:hover': {
                background: 'linear-gradient(135deg, #0a58ca 0%, #084298 100%)',
                boxShadow: '0 8px 25px rgba(13, 110, 253, 0.3)'
              }
            }}
          >
            {saving ? 'Saving...' : 'Save Site'}
          </ActionButton>
        </Box>
      </form>

      {/* Context Menu */}
      <StyledMenu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={handleMenuClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleMenuClose}>
          <ListItemIcon>
            <ExportIcon sx={{ color: '#4caf50' }} />
          </ListItemIcon>
          <ListItemText primary="Export Data" />
        </MenuItem>
        
        <MenuItem onClick={handleMenuClose}>
          <ListItemIcon>
            <DeleteIcon sx={{ color: '#f44336' }} />
          </ListItemIcon>
          <ListItemText primary="Delete Site" />
        </MenuItem>
      </StyledMenu>
    </StyledContainer>
  );
}

export default SiteContact;